export class ModalComponentMock {
  public open(ignore) {}
}



// WEBPACK FOOTER //
// ./src/app/shared/tests/modal.component.mock.ts